import { API_URL } from "./api";

/** Errore che porta con sé lo stato HTTP e il codice applicativo dell'API. */
export class ApiRequestError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly code?: string,
  ) {
    super(message);
    this.name = "ApiRequestError";
  }
}

/**
 * Chiamata all'API con la sessione.
 *
 * `credentials: "include"` non è opzionale: senza, il cookie di sessione non
 * parte e ogni rotta protetta risponde 401 senza spiegazioni.
 */
export async function request<T>(method: string, path: string, body?: unknown): Promise<T> {
  let response: Response;

  try {
    response = await fetch(API_URL + path, {
      method,
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      ...(body === undefined ? {} : { body: JSON.stringify(body) }),
    });
  } catch {
    throw new ApiRequestError(`Impossibile raggiungere ${API_URL}. L'API è avviata?`, 0);
  }

  const text = await response.text();
  const payload: unknown = text ? JSON.parse(text) : null;

  if (!response.ok) {
    const problem = payload as { error?: string; message?: string } | null;
    throw new ApiRequestError(
      problem?.message ?? `Richiesta fallita (${response.status})`,
      response.status,
      problem?.error,
    );
  }

  return payload as T;
}
